import { create } from 'zustand';

interface ExchangeState {
  exchanges: Record<string, any>;
}

export const useExchangeStore = create<ExchangeState & { fetchExchanges: () => Promise<void> }>((set) => ({
  exchanges: {},
  fetchExchanges: async () => {
    try {
      const res = await fetch('/api/exchanges');
      const data = await res.json();
      set({ exchanges: data });
    } catch (e) {
      // handle error
    }
  },
}));